module.exports = __webpack_public_path__ + "r-v3/img/kakao.4d890ddf.png";